import { PreProcessor } from 'api/requestUtils'

const bodyMethods = new Set(['POST', 'PUT', 'PATCH'])
export default function brandLoader(brand: string): PreProcessor {
  return (params) => {
    const { options, path } = params

    // Hmm... is it safe to remove without_brand=1 here?
    if (path.includes('without_brand=1') || path.includes('/api/trips') || path.includes('/api/search/place/v1/places/')) {
      return params
    }

    if (bodyMethods.has(options.method)) {
      const isFormData = options.body instanceof FormData
      if (isFormData) {
        options.body.append('brand', brand)
      } else {
        options.body = {
          ...options.body,
          brand,
        }
      }
    } else {
      if (!path.includes('without_brand=1')) {
        if (params.path.endsWith('?')) {
          params.path += `brand=${brand}`
        } else if (params.path.includes('?')) {
          params.path += `&brand=${brand}`
        } else {
          params.path += `?brand=${brand}`
        }
      }
    }
    return params
  }
}
